module.exports = __webpack_public_path__ + "img/inu_gallery10.a84d2239.jpg";